import { PageContainer, Spinner, useRemoteConfig } from "@shapr3d/frontend-lib";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

import { OverlayProvider } from "../../components/Headers/components/ShareModal/components/MenuPortal";
import { ViewLinkList } from "../../components/ViewLinkList/ViewLinkList";
import { useGuardPrivateCloudTeams } from "../../hooks/useGuardPrivateCloudTeams";
import { useGuardSyncOffTeams } from "../../hooks/useGuardSyncOffTeams";
import { useProjectViewLinkList } from "../../hooks/useProjectViewLink";
import { useTeam } from "../../hooks/useTeams";

import style from "./ViewLinkListPage.module.css";

function ViewLinkListPageComponent() {
  const { teamID } = useParams();
  const { teamData } = useTeam(teamID);
  const isPrivateCloudTeam = Boolean(teamData?.addons?.privateCloud);

  const privateCloudViewLinksFlag = useRemoteConfig("web_private_cloud_view_links-ff");
  const isPrivateCloudViewLinksEnabled = Boolean(privateCloudViewLinksFlag);
  const isPrivateCloudViewLinksFlagResolved = privateCloudViewLinksFlag !== undefined;
  const shouldGuardPrivateCloudTeams =
    isPrivateCloudTeam && isPrivateCloudViewLinksFlagResolved && !isPrivateCloudViewLinksEnabled;
  const shouldBlockViewLinksFetch = isPrivateCloudTeam && !isPrivateCloudViewLinksFlagResolved;

  const isRedirecting = useGuardPrivateCloudTeams({ enabled: shouldGuardPrivateCloudTeams });
  useGuardSyncOffTeams({ enabled: !isRedirecting });

  const { data, isLoading } = useProjectViewLinkList({
    teamId: teamID,
    latestByProject: true,
    enabled: !shouldBlockViewLinksFetch,
  });

  if (shouldBlockViewLinksFetch || isLoading) {
    return (
      <div className={style.pageContainer}>
        <Spinner />
      </div>
    );
  }

  return (
    <OverlayProvider>
      <PageContainer title="Published versions">
        <ViewLinkList
          viewLinks={data?.projectViewLinks ?? []}
          users={data?.users ?? []}
          telemetryLocation="review_links"
          isUnpublishHidden
        />
      </PageContainer>
    </OverlayProvider>
  );
}

export default function ViewLinkListPage() {
  return (
    <>
      <Helmet>
        <title>Shapr3D - Dashboard</title>
        <meta
          name="description"
          content="Review designs together. View models and add comments directly to your 3D design."
        />
      </Helmet>
      <ViewLinkListPageComponent />
    </>
  );
}
